import { render, staticRenderFns } from "./NavsPage.vue?vue&type=template&id=7b3920bb&"
import script from "./NavsPage.vue?vue&type=script&lang=js&"
export * from "./NavsPage.vue?vue&type=script&lang=js&"
import style0 from "./NavsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports